'use strict';

const {degToRad} = require('./utils/misc');

const offset = 0;

String.prototype.capitalize = function() {
    const words = this.split(' ');
    return words.map((word) => {
        return word[0].toUpperCase() + word.slice(1);
    }).join(' ');
};

Array.prototype.rand = function () {
    const i = Math.floor(Math.random() * this.length);
    return this[i];
};

CanvasRenderingContext2D.prototype.dot = function dot (point, size) {
    this.beginPath();
    this.fillStyle = '#000';
    this.arc(point.x + offset, point.y + offset, size || 0.1, degToRad(0), degToRad(360), false);
    this.fill();
};

CanvasRenderingContext2D.prototype.moveToPoint = function (point) {
    return this.moveTo(point.x + offset, point.y + offset);
};

CanvasRenderingContext2D.prototype.lineToPoint = function (point) {
    return this.lineTo(point.x + offset, point.y + offset);
};

CanvasRenderingContext2D.prototype.clearRectFromPoint = function (point, width, height) {
    return this.clearRect(point.x + offset, point.y + offset, width, height);
};

CanvasRenderingContext2D.prototype.fillTextAtPoint = function (text, point) {
    return this.fillText(text, point.x + offset, point.y + offset);
};

